/** Stable identity for the bundled, ordinary workspace that carries demo data. */

export const DEMO_WORKSPACE_NAME = "Demo Organization";
export const DEMO_WORKSPACE_SLUG = "excellent-demo";

export function isBundledSampleWorkspaceSlug(slug: string | null | undefined): boolean {
  return slug === DEMO_WORKSPACE_SLUG;
}

export function isDemoWorkspaceSlug(slug: string | null | undefined): boolean {
  return isBundledSampleWorkspaceSlug(slug);
}
